import { render, staticRenderFns } from "./CreditorAccessSection.vue?vue&type=template&id=46cc2f4f&scoped=true"
import script from "./CreditorAccessSection.vue?vue&type=script&lang=js"
export * from "./CreditorAccessSection.vue?vue&type=script&lang=js"
import style0 from "./CreditorAccessSection.vue?vue&type=style&index=0&id=46cc2f4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc2f4f",
  null
  
)

export default component.exports